import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const AppFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <Container>
        <div className="app-footer__content">
          <div>
            <div className="app-footer__brand">NPI Governance Solutions</div>
            <p className="app-footer__text">
              Access70 LMS supports learner administration, resources, assessments, attendance, reporting, and programme communications.
            </p>
          </div>
          <nav className="app-footer__links" aria-label="Legal links">
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/data-collection-policy">Data Collection</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </nav>
        </div>
        <div className="app-footer__bottom">
          <span>&copy; {year} NPI Governance Solutions. All rights reserved.</span>
          <span>Access70 LMS</span>
        </div>
      </Container>
    </footer>
  );
};

export default AppFooter;
